import { baseUrl } from "../../../boot/index";
import axios from "axios";

// Add Location
export const addLocation = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/operations/app/v1/create-locations`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log({ error })
    throw error
  }
}

// update location
export const updateLocation = async (data) => {
  console.log({ data })
  const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/operations/app/v1/update-locations/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
// delete Location 
export const deleteLocation = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/operations/app/v1/delete-locations/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}

// total count
export const countLocation = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/operations/app/v1/count-locations`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
// Get Location by ID
export const getLocationById = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/operations/app/v1/getlist-locations/${id}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
